import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URL from "helpers/url_helper";
import { get, post, del, put } from "helpers/api_helper";
import { toast } from "react-toastify";
import { getValuesSocketData } from "helpers/secretManager";

export const updateHistoricalDataSettings = createAsyncThunk(
  "updateHistoricalDataSettings",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      let response = await post(URL.UPDATE_HISTORICAL_DATA_SETTING, data, {
        signature,
        nonce,
      });
      if (response?.status === "failure") {
        toast.error(response?.message || "Something went wrong!");

        return callback && callback(response?.message, null);
      }
      callback && callback(null, response.data);
      toast.success("Settings updated successfully!");
      return response.data;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const getMongoSQLSetting = createAsyncThunk(
  "getMongoSQLSetting",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(`${URL.GET_MONGOSQL_SETTING}`, data, {
        signature,
        nonce,
      });
      callback && callback(null, response.data);
      return response;
    } catch (error) {
      return Thunk.rejectWithValue(error);
    }
  },
);

export const mongoSQLSettingDetail = createAsyncThunk(
  "mongoSQLSettingDetail",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await get(
        URL.GET_MONGOSQL_SETTING_DETAILS + "/" + data?._id,
        { signature, nonce },
      );
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      console.error(error, "<===error");
      toast.error(error?.message || "Something went wrong!");
      callBack && callBack(error?.message || "Something went wrong!");

      return Thunk.rejectWithValue(error);
    }
  },
);

export const getRemoveFromMongo = createAsyncThunk(
  "getRemoveFromMongo",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(`${URL.GET_REMOVE_FROM_MONGO}`, data, {
        signature,
        nonce,
      });
      callback && callback(null, response.data);
      return response;
    } catch (error) {
      return Thunk.rejectWithValue(error);
    }
  },
);

export const removeFromMongoDetail = createAsyncThunk(
  "mongoSQLSettingDetail",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await get(
        URL.GET_REMOVE_FROM_MONGO_DETAILS + "/" + data?._id,
        { signature, nonce },
      );
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      console.error(error, "<===error");
      toast.error(error?.message || "Something went wrong!");
      callBack && callBack(error?.message || "Something went wrong!");

      return Thunk.rejectWithValue(error);
    }
  },
);

export const deleteMongoSQLSetting = createAsyncThunk(
  "deleteMongoSQLSetting",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(`${URL.DELETE_MONGOSQL_SETTING}`, data, {
        signature,
        nonce,
      });
      callback && callback(null, response.data);
      return response;
    } catch (error) {
      callback && callback(error, null);
      return Thunk.rejectWithValue(error);
    }
  },
);
